const createImageObject = (source) => {
  if (!source) return null;

  return {
    damDownloadedContent: {
      url: source.uri
    },
    imageHotspot: source.hotspot ? {
      id: source.hotspot,
      componentName: 'ImageHotspot'
    } : null
  };
};

const normalizeSlotSource = (slot, mediaCollectionIndex, desktopSourceData, mobileSourceData) => {
  const mediaCollection = slot.mediaCollections?.[mediaCollectionIndex];
  const media = mediaCollection?.media?.[0];

  if (!media) {
    return null;
  }

  const sourceDesktop = media.sourceDesktop?.[0];
  const sourceMobile = media.sourceMobile?.[0];

  return {
    source: 'slot',
    id: slot.id,
    entryId: slot.entryId,
    componentName: media.title,
    link: sourceDesktop?.hyperlink || sourceMobile?.hyperlink || '',
    altText: sourceDesktop?.altText || sourceMobile?.altText || '',
    desktopImage: createImageObject(sourceDesktop),
    mobileImage: createImageObject(sourceMobile),
    tabletImage: createImageObject(sourceDesktop),
    theme: mediaCollection?.theme || null,
    desktopSourceData: sourceDesktop,
    mobileSourceData: sourceMobile
  };
};

export const normalizeSlotData = ({ slotData, componentData, mediaCollectionIndex }) => {

  if (slotData?.slot) {
    return normalizeSlotSource(slotData.slot, mediaCollectionIndex);
  }

  if (componentData?.component) {
    return {
      source: 'component',
      ...componentData.component
    };
  }

  return null;
};
